import { AppProvider } from '@/context/AppContext'
import { type Apps } from '@/dtos'
import { CustomToastContainer } from 'BrokerTsLib/src/components'
import { Outlet } from 'react-router-dom'

export interface AppLayoutProps {
  app: Apps | null
}

export const AppLayout = ({app}: AppLayoutProps) =>{

  return <AppProvider app={app}>
    <Outlet />
    
    <CustomToastContainer />
  </AppProvider>
}